import Path from './route';

function App() {
	return (
		<div className='App'>
			<Path />
		</div>
	);
}

export default App;
